import React, { Component } from "react";
import request, { tracesToken } from "../../lib/requester";
import _, { toNumber } from "lodash";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import Autocomplete from "../../component/autocomplete";
import axios from "axios";
import { Modal, Select } from "antd";

import * as Minio from "minio";

const minioClient = new Minio.Client({
  endPoint: "s3.dexagroup.com",
  accessKey: "aam-traces",
  secretKey: "BkwJ0bdaNaSPl44tzxwC01Z6nsAM!U",
});

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerChannel: "",
      lovSupplierSite: [],
      lovSupplier: [],
      supplier: null,
      supplierId: 0,
      supplierSite: 0,
      orgId: "",
      skbNumber: "",
      orgInitial: "",
      claimExpDate: "",
      totalSelectedAmount: 0,
      accOwner: "",
      bankName: "",
      showSkbAttachment: false,
      skb: "N",
      taxNo: "",
      taxDate: new Date(),

      npwp: "",
      norek: "",
      paymentMethod: "",
      loading: false,
      principalName: "",
      description: "",
      refNumber: "",
      programType: "",
      customerName: "",
      potongTagihan: "",
      pphRate: 0,
      pphType: "",
      dpp: 0,
      ppn: 0,
      ppnrate: 11,
      pph: 0,
      totalAmount: 0,
      docs: [],
      productList: [],
      fileContainer: [],
      error: [],
      success: "",
      branchId: "",
      customerId: "",
      listInvoice: [],
      selectedInvoice: [],
      fileSKB: { filename: "", path: "" },
      fileLain: { filename: "", path: "" },
      fileTambahan: { filename: "", path: "" },
      fileRequired: { filename: "", path: "" },
      lovPPH: [],
      user: JSON.parse(window.localStorage.getItem("is_user")) || {},
      submitteddate: "",
      skpnumber: "",
      branchCode: "",
      startDate: new Date(),
      endDate: new Date(),
      sisabudget: 0,
      programNumber: "",
      budgetType: "",
      program_budget: 0,
      assign_budget: 0,
      sales_target: 0,
      kwitansi: "",
      item_actual_temp: "",
      header_npwp: "",
      header_npwp_name: "",
      header_npwp_address: "",
      additionalAttachment: 0,
      documentList: [],
      skbDateFrom: null,
      skbDateTo: null,
      kwitansiDate: new Date(),
      kwitansiAmount: 0,
      notes: "",
      //
      claimnumber: "",
      newFile: "",
      objUlr: "",
      newAdditionalFile: "",
      objUrlAdditional: "",
    };
  }

  componentDidMount = () => {
    this.getPPNRATE(new Date());
    this.getDetailProgram();
    this.getPPHType();
  };

  getChannelCustomer = (customerId) => {
    // let url = 'https://api-digifin.dexagroup.com/collection/v1/customer/mapping-coll'
    const url = `${process.env.REACT_APP_COLLECTION_URL}/v1/customer/mapping-coll`;
    let param = {
      customerId: customerId,
    };
    axios
      .post(
        url,
        param,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_COLLECTION_TOKEN}`,
            "api-key": process.env.REACT_APP_COLLECTION_API_KEY,
          },
        },
        param
      )
      .then((response) => {
        let rs = response.data;
        this.setState({ customerChannel: rs.data.SALES_CHANNEL_COLL || "" });
      })
      .catch((e) => {
        console.log(e.message);
      });
  };

  getInvoice = () => {
    let url = "/api/orafin/v1/claim/list-invoice";
    let param = {
      branchId: this.state.branchId,
      customerId: this.state.customerId,
    };
    request.postOracle(url, param, {
      success: function (response) {
        let invoice = response.data.data;
        invoice = invoice.map((item, index) => {
          item.ADJUST = item.OUTSTANDING_AMOUNT;
          return item;
        });
        this.setState({ listInvoice: invoice });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  getPPNRATE = (taxdate) => {
    let url = "/api/traces/v1/claim/get-ppn-rate-oracle";
    let { id } = this.props.match.params;
    let param = {
      program_customer_id: id,
      tax_date: taxdate,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { ppnrate } = response.data.data;
        this.setState({
          ppnrate: ppnrate,
        });

        let dpp = this.removeSeparator(this.state.dpp);
        let rate = (dpp * ppnrate) / 100;

        this.setState({
          ppn: rate,
        });

        this.setState({ loading: false });
        // this.getInvoice();
        // this.getNpwp()
        let app = this;
        window.setTimeout(() => {
          app.calculateAmount();
          this.setState({ loading: false });
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getDetailProgram = () => {
    let url = "/api/traces/v1/claim/detail";
    let { id } = this.props.match.params;
    let param = {
      program_customer_id: id,
    };
    this.setState({ loading: true });
    request.postTraces(url, param, {
      success: function (response) {
        let { header, npwp, document, product } = response.data.data;
        this.setState({
          // ppnrate: ppnrate,
          claimnumber: header.claim_number,
          programNumber: header.program_number,
          budgetType: header.budget_type,
          sisabudget: header.sisa_budget,
          program_budget: header.program_budget,
          assign_budget: header.assign_budget,
          sales_target: header.sales_target,
          branchCode: header.branch_code,
          orgInitial: header.org_initial,
          orgId: header.org_id,
          loading: false,
          principalName: header.org_name,
          refNumber: header.ref_number,
          skpnumber: header.skp_number,
          programType: header.program_name,
          description: header.description,
          branchId: header.branch_id,
          customerId: header.customer_id,
          programId: header.program_id,
          customerName: header.customer_name || "",
          // dpp: this.thousandSeparator(header.budget),
          // ppn: this.thousandSeparator(parseInt(header.budget) / 10),
          // dpp: this.thousandSeparator(header.sisa_budget),
          //ppn: this.thousandSeparator(parseInt(header.sisa_budget) / 10),
          pphRate: header.pph_rate,
          pphType: header.pph_type,
          docs: document,
          productList: product,
          // pph: this.thousandSeparator(parseInt(header.pph_rate) / 100 * parseInt(this.removeSeparator(header.budget))), // Rate PPH * DPP
          // pph: this.thousandSeparator(parseInt(header.pph_rate) / 100 * parseInt(this.removeSeparator(header.sisa_budget))), // Rate PPH * DPP
          submitteddate: moment(header.creation_date).format("DD-MMM-YYYY"),
          claimExpDate: moment(header.claim_exp_date).format("DD-MMM-YYYY"),
          startDate: moment(header.start_date).format("DD-MMM-YYYY"),
          endDate: moment(header.end_date).format("DD-MMM-YYYY"),
          paymentMethod: header.org_initial === "AAM" ? "TRF" : "",
          // Added By Joy | 7 March 2023
          header_npwp: npwp ? npwp.NPWP_NUMBER : "",
          header_npwp_name: npwp ? npwp.NPWP_NAME : "",
          header_npwp_address: npwp ? npwp.NPWP_ADDRESS : "",
        });
        this.getInvoice();
        // this.getNpwp();
        this.getChannelCustomer(header.customer_id);
        let app = this;
        window.setTimeout(() => {
          app.calculateAmount();
        }, 200);
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getPPHType = () => {
    let url = "/api/traces/v1/general/pph-type";
    request.getTraces(url, {
      success: function (response) {
        this.setState({ lovPPH: response.data.data });
      }.bind(this),
      error: function (e) {
        console.log(e);
      },
    });
  };

  onSelectSupplier = (item, index) => {
    this.setState({ supplier: item.label, supplierId: item.value });
    this.getSupplierSite(item.value);
  };

  getSupplierSite = (id) => {
    if (!id || id.length === 0) {
      return false;
    }
    let url = "/api/orafin/v1/claim/list-supplier-site";
    let param = { supplier_id: id };
    this.setState({ loading: true });
    request.postOracle(url, param, {
      success: function (response) {
        let { data } = response.data;
        let lovSupplierSite = [];
        data.forEach((item, index) => {
          lovSupplierSite.push({
            SUPPLIER_SITE_CODE: item.VENDOR_SITE_CODE,
            SUPPLIER_SITE_ID: item.VENDOR_SITE_ID,
          });
        });
        this.setState({ lovSupplierSite: lovSupplierSite, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  getNpwp = () => {
    let url = "/api/orafin/v1/general/npwp-customer";
    let param = {
      customerid: this.state.customerId,
      branchId: this.state.branchId,
    };
    this.setState({ loading: true });
    request.postOracle(url, param, {
      success: function (response) {
        let { data } = response.data;
        this.setState({
          npwp: data.npwp,
          header_npwp: data.npwp,
          header_npwp_name: data.name,
          header_npwp_address: data.address,
          loading: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  onChangeAutocomplete = (q) => {
    let param = {
      supplier_name: q,
    };
    return new Promise((resolve, reject) => {
      request.postOracle("/api/orafin/v1/claim/list-supplier", param, {
        success: (response) => {
          let { data } = response.data;
          let lovSupplier = [];
          data.forEach((item, index) => {
            lovSupplier.push({ text: item.VENDOR_NAME, value: item.VENDOR_ID });
          });

          // Simpan hasil ke dalam state
          this.setState({ lovSupplier: lovSupplier });

          resolve(lovSupplier);
        },
        error: (e) => {
          // Jika terjadi error, atur state menjadi array kosong
          this.setState({ lovSupplier: [] });
          resolve([]);
        },
      });
    });
  };

  renderNorek = () => {
    if (
      this.state.paymentMethod === "TRF" ||
      (this.state.paymentMethod === "DEP" && this.state.orgInitial === "AAM")
    ) {
      // if (this.state.orgInitial === 'AAM') {
      if (1 === 1) {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Supplier
              </label>
              <div className="col-sm-9">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={this.state.lovSupplier.map((item) => {
                    return {
                      label: item.text,
                      value: item.value,
                    };
                  })}
                  labelInValue
                  allowClear={false}
                  placeholder={this.state.supplier ? "Search..." : "Search..."}
                  onSearch={(value) => this.onChangeAutocomplete(value)}
                  className="w-100"
                  size="large"
                  onSelect={(e) => {
                    this.setState({
                      supplier: null,
                      supplierId: "",
                      supplierSite: "",
                    });
                    this.onSelectSupplier(e);
                  }}
                  value={this.state.supplier}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Supplier Site
              </label>
              <div className="col-sm-9">
                <select
                  className="form-control"
                  value={this.state.supplierSite}
                  name="supplierSite"
                  onChange={this.handleChangeInput.bind(this)}
                >
                  <option value="">- Select Supplier Site -</option>
                  {this.state.lovSupplierSite.map((item, index) => (
                    <option value={item.SUPPLIER_SITE_ID}>
                      {item.SUPPLIER_SITE_CODE}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Account No
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="norek"
                  placeholder="Account No"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.norek}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Bank Name
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="bankName"
                  placeholder="Bank Name"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.bankName}
                />
              </div>
            </div>
            <div className="form-group row">
              <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
                Account Owner
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id="inputEmail3"
                  name="accOwner"
                  placeholder="Account Owner"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.accOwner}
                />
              </div>
            </div>
          </div>
        );
      }
    }
  };

  renderLovPPh = () => {
    return (
      <select
        disabled
        className="form-control"
        name="pphType"
        value={this.state.pphType}
        onChange={this.handleChangeInput.bind(this)}
      >
        <option>- Select Type -</option>
        {this.state.lovPPH.map((item, index) => (
          <option value={item.pph_type} key={index}>
            {item.pph_type}
          </option>
        ))}
      </select>
    );
  };

  showError = () => {
    if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
      );
    }
  };

  showSuccess = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fas fa-check"></i> {this.state.success}
        </div>
      );
    }
  };

  thousandSeparator = (value) => {
    value = value.toString();
    value = value.replace(/,/g, "").replace(/(?!^-)[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (value.length === 0) return 0;
    value = value.toString();
    return value.replace(/,/g, "");
  };

  calculateAmount = () => {
    let { dpp, ppn, pph, totalAmount } = this.state;
    totalAmount =
      (parseFloat(this.removeSeparator(dpp)) || 0) +
      (parseFloat(this.removeSeparator(ppn)) || 0) -
      (parseFloat(this.removeSeparator(pph)) || 0);
    totalAmount = Math.round(totalAmount); // ilham, menambahkan round
    this.setState({
      totalAmount: this.thousandSeparator(totalAmount),
      ppn: this.thousandSeparator(ppn),
    });
    console.log(this.state.totalAmount);
  };

  handleKwitansiDate = (date) => {
    this.setState({ kwitansiDate: date });
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "pph" || name === "ppn" || name === "dpp") {
      value = this.thousandSeparator(value);
    } else if (name === "pphRate") {
      // value = value.replace(/[^0-9.]/g, "").replace(/\./g, "");
      if (parseFloat(value) > 100) value = 100;
      if (parseFloat(value) < 0) value = 0;
    }

    this.setState({ [name]: value });
    if (
      name === "pph" ||
      name === "ppn" ||
      name === "dpp" ||
      name === "pphRate"
    ) {
      let app = this;
      if (name === "dpp") {
        let ppn = this.thousandSeparator(
          // parseInt(this.removeSeparator(value)) / 10
          (parseInt(this.removeSeparator(value)) * this.state.ppnrate) / 100
        );
        app.setState({ ppn: ppn });
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      } else if (name === "pphRate") {
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      }
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }

    // if (name === "headerNpwp") {
    //   this.setState({ header_npwp: value });
    // }

    // if (name === "headerNpwpName") {
    //   this.setState({ header_npwp_name: value });
    // }

    // if (name === "headerNpwpAddress") {
    //   this.setState({ header_npwp_address: value });
    // }
  };

  handleChangeKwitansi = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    this.setState({ kwitansi: value });
  };

  handlekwitansiAmount = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    value = this.thousandSeparator(value);

    this.setState({ kwitansiAmount: value });
  };

  countPPH = () => {
    let { dpp, pphRate } = this.state;
    let pph = this.thousandSeparator(
      Math.round(
        (parseFloat(pphRate || 0) / 100) * parseInt(this.removeSeparator(dpp))
      )
    );
    this.setState({ pph: pph });
  };

  renderDocument = () => {
    return this.state.docs.map((item, index) => (
      <div className="row mb-2" key={index}>
        <div className="col-md-2 mt-2">{item.document_name}</div>
        <div className="col-md-3">
          <input
            type="file"
            className="form-control"
            data-index={index}
            data-program-doc-id={item.program_doc_id}
            onChange={this.handleUpload.bind(this)}
          />
        </div>
        <div className="col-md-7 mt-2">{this.renderUploadedFile(index)}</div>
      </div>
    ));
  };

  renderDocumentV2 = () => {
    let { fileRequired } = this.state;
    if (fileRequired.path === "") {
      return this.state.docs.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.program_doc_id}
                onClick={this.handleClickDocument.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ));
    } else {
      return this.state.docs.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ));
    }
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList, fileRequired } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.program_doc_id) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  renderProduct = () => {
    // console.log(this.state.productList)
    return this.state.productList.map((item, index) => (
      <div className="row mb-2" key={index}>
        <div className="col-sm-4">
          <input
            disabled
            type="text"
            className="form-control"
            name="productname"
            value={item.item_description}
          />
        </div>
        <div className="col-sm-2">
          <input
            disabled
            type="text"
            className="form-control"
            name="itemReff"
            value={item.item_reff}
          />
        </div>
        <div className="col-sm-2">
          <input
            disabled
            type="text"
            className="form-control"
            name="itemBudget"
            // value={item.item_budget}
            value={
              item.item_budget
                ? item.item_budget.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : 0
            }
          />
        </div>
        <div className="col-sm-2">
          <input
            type="text"
            className="form-control"
            name="itemActual"
            currentindex={index}
            value={item.item_actual_formatted}
            // currentvalue={item.item_actual_formatted}
            placeholder="actual"
            defaultValue={item.item_actual}
            onChange={this.onChangeProductActual.bind(this)}
          />
        </div>
      </div>
    ));
  };

  onChangeProductActual = (event) => {
    let value = event.target.value;
    let currentindex =
      event.target.attributes.getNamedItem("currentindex").value;

    let { productList } = this.state;
    productList[currentindex].item_actual = this.removeSeparator(value);
    productList[currentindex].item_actual_formatted =
      this.thousandSeparator(value);
    this.setState(productList);

    let app = this;
    window.setTimeout(() => {}, 100);
  };

  onChangeProductActualOri = (event) => {
    let value = event.target.value;
    let currentindex =
      event.target.attributes.getNamedItem("currentindex").value;

    let { productList } = this.state;
    if (this.state.dpp == "0") {
      alert("Isi DPP terlebih dahulu.");
      // productList[currentindex].item_budget = "0"
      // this.removeProduct(currentindex)
      // document.getElementById("itemBudget").value = "0"
    } else {
      productList[currentindex].item_actual = value;
      let sumActual = 0;
      let dpp = 0;
      dpp = toNumber(this.removeSeparator(this.state.dpp));

      for (var i = 0; i < productList.length; i++) {
        console.log(toNumber(productList[i].item_actual));
        sumActual = sumActual + toNumber(productList[i].item_actual);
        // i++
      }
      console.log(sumActual);
      if (sumActual > dpp) {
        alert("actual product tidak boleh melebihi DPP.");
        productList[currentindex].item_actual = "";
      } else {
        productList[currentindex].item_actual = value;
      }

      this.state.item_actual_temp = toNumber(sumActual);

      console.log(productList);
    }
  };

  handleUpload = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let { programDocId, index } = e.target.dataset;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [];
    if (this.state.orgInitial === "FFI") {
      allowedFile = ["pdf"];
    } else {
      allowedFile = ["jpg", "png", "jpeg", "gif", "pdf"];
    }

    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyTraces("/api/traces/v1/general/upload-file", data, {
      success: function (response) {
        let data = response.data;
        let container = this.state.fileContainer;
        data.program_doc_id = programDocId;
        data.index = index;
        data.path = data.fullurl;
        container.push(data);
        this.setState({ fileContainer: container, loading: false });
        this.forceUpdate();
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  handleUploadSingle = async (e) => {
    this.setState({ loading: true });

    let files = e.target.files[0];
    let doctype = e.target.dataset.type;
    // // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];

    if (doctype === "TAMBAHAN") {
      this.setState({
        newAdditionalFile: e.target.files[0],
        objUrlAdditional: URL.createObjectURL(e.target.files[0]),
      });
    } else if (doctype === "REQUIRED") {
      this.setState({
        newFile: e.target.files[0],
        objUlr: URL.createObjectURL(e.target.files[0]),
      });
    }

    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);

    const presignedUrl = async (fileName) => {
      try {
        const policy = minioClient.newPostPolicy();
        policy.setKey(fileName);
        policy.setBucket("aam-traces");

        const expires = new Date();
        expires.setSeconds(24 * 60 * 60 * 10); // 10 days expiry.
        policy.setExpires(expires);
        return await minioClient.presignedPostPolicy(policy);
      } catch (error) {
        console.log(error);
        this.warning("Failed code : Failed create presign URL");
      }
    };

    const uploadToS3 = async (obj, file) => {
      try {
        const formData = new FormData();
        Object.entries(obj.formData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append("file", file);
        return await axios.post(obj.postURL, formData);
      } catch (error) {
        console.log("upload s3 : ", error);
        this.warning(
          "Failed code : Failed upload to S3 after create presign URL"
        );
      }
    };

    try {
      let folder =
        doctype === "SKB"
          ? "skb"
          : doctype === "LAIN"
          ? "lain"
          : doctype === "TAMBAHAN"
          ? "additional"
          : doctype === "REQUIRED"
          ? "mandatory"
          : "";
      const fileNameToMinio = `/${folder}/${filename}`;
      const minioUrl = await presignedUrl(fileNameToMinio);
      const uploadFilePdf = await uploadToS3(minioUrl, files);
      if (uploadFilePdf?.status === 204) {
        if (doctype === "SKB") {
          let { fileSKB } = this.state;
          fileSKB.filename = filename;
          fileSKB.path = minioUrl.formData.key;
          this.setState(fileSKB);
        } else if (doctype === "LAIN") {
          let { fileLain } = this.state;
          fileLain.filename = filename;
          fileLain.path = minioUrl.formData.key;
          this.setState(fileLain);
        } else if (doctype === "TAMBAHAN") {
          let { fileTambahan } = this.state;
          fileTambahan.filename = filename;
          fileTambahan.path = minioUrl.formData.key;
          this.setState(fileTambahan);
        } else if (doctype === "REQUIRED") {
          let { fileRequired } = this.state;
          fileRequired.filename = filename;
          fileRequired.path = minioUrl.formData.key;
          this.setState(fileRequired);
        }
        this.setState({ loading: false });
        this.success();
      } else {
        this.setState({ loading: false, error: ["Failed to submit"] });
        this.warning("Failed code");
      }
    } catch (error) {
      this.warning("Failed. please try again");
      this.setState({ loading: false, error: ["Failed to submit"] });
    }
  };

  success = () => {
    Modal.success({
      title: "Success",
      content: "Success Upload",
      onOk() {
        // setData([]);
      },
    });
  };

  warning = (message) => {
    Modal.warning({
      title: "Failed",
      content: message,
      onOk() {
        // setData([]);
      },
    });
  };

  renderUploadedFile = (index) => {
    let { fileContainer } = this.state;
    let find = _.find(fileContainer, function (o) {
      return parseInt(o.index) === parseInt(index);
    });
    if (find) {
      return (
        <span>
          <Link to={{ pathname: find.path }} target="_blank">
            {find.filename}{" "}
          </Link>
          &nbsp;
          <button
            type="button"
            className="btn btn-danger"
            data-index={index}
            onClick={() => {
              this.removeFile(index);
            }}
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </span>
      );
    }
  };

  removeFileAdditional = (type) => {
    if (type === "lain") {
      let { fileLain } = this.state;
      fileLain.filename = "";
      fileLain.path = "";
      this.setState(fileLain);
    } else if (type === "tambahan") {
      let { fileTambahan } = this.state;
      fileTambahan.filename = "";
      fileTambahan.path = "";
      this.setState(fileTambahan);
    }
  };

  removeFile = (index) => {
    let indexing = _.findIndex(this.state.fileContainer, function (o) {
      return parseInt(o.index) === parseInt(index);
    });
    if (indexing >= 0) {
      let container = this.state.fileContainer;
      container.splice(indexing, 1);
      this.setState(container);
    }
  };

  validateForm = () => {
    let {
      kwitansi,
      ppn,
      paymentMethod,
      npwp,
      header_npwp,
      pphType,
      dpp,
      fileContainer,
      totalAmount,
      docs,
      selectedInvoice,
      bankName,
      accOwner,
      taxDate,
      taxNo,
      sisabudget,
      item_actual_temp,
      productList,
      documentList,
      skbDateFrom,
      skbDateTo,
      skb,
      kwitansiAmount,
      kwitansiDate,
    } = this.state;
    let error = [];

    if (this.state.fileRequired.filename === "") {
      error.push("Please complete the required attachments");
    }
    if (parseInt(this.removeSeparator(ppn)) > 0) {
      if (taxDate.length === 0) {
        error.push("Tax Date is empty");
      }
      if (taxNo.length === 0) {
        error.push("Tax No is empty");
      } else {
        let count = taxNo.replace(/\.|-/g, "");
        if (count.length < 16 || count.length > 17) {
          error.push(
            "Invalid Tax No, must be contain 16 or 17 digits (exclude . & -)"
          );
        }
      }
    }
    if (paymentMethod.length === 0) {
      error.push("Please select payment method");
    }
    // if (header_npwp.length === 0) {
    //   error.push("NPWP is empty");
    // }
    if (kwitansi.length === 0) {
      error.push("Kwitansi is empty");
    }
    if (kwitansiAmount == 0) {
      error.push("Kwitansi amount is empty");
    }
    if (kwitansiDate.length === 0) {
      error.push("Kwitansi date is empty");
    }
    if (!pphType || pphType === "") {
      error.push("Please select PPh Type");
    }
    if (parseInt(dpp) === 0 || dpp.length === 0) {
      error.push("DPP is empty");
    }

    // if (fileContainer.length < docs.length) {
    //   error.push("Please complete the required attachments");
    // }
    if (documentList.length < docs.length) {
      error.push("Please checked the required attachments file");
    } else {
      // if (this.state.fileRequired.path.length === 0) {
      //   error.push("Upload the required attachment");
      // }
    }

    // Validation Product
    let totalAmountProduct = 0;
    productList.forEach((item, index) => {
      totalAmountProduct += parseInt(item.item_actual || 0);
    });

    if (
      totalAmountProduct > 0 &&
      totalAmountProduct !== parseInt(this.removeSeparator(dpp))
    ) {
      error.push("Total actual of products must be 0 or equal with DPP");
    }

    if (this.state.paymentMethod === "INV") {
      // Invoice Amount Validation
      let app = this;
      let countAmount = 0;
      selectedInvoice.forEach((item, index) => {
        let find = _.find(app.state.listInvoice, function (o) {
          return parseInt(o.CUSTOMER_TRX_ID) === parseInt(item.CUSTOMER_TRX_ID);
        });
        if (find) {
          item.CUSTOMER_TRX_ID = find.CUSTOMER_TRX_ID;
          item.INVOICE_DATE = moment(new Date(find.INVOICE_DATE)).format(
            "YYYY-MM-DD"
          );
          item.INVOICE_NUMBER = find.INVOICE_NUMBER;
          item.OUTSTANDING_AMOUNT = find.OUTSTANDING_AMOUNT;
          item.OUTSTANDING_FORMATTED = find.OUTSTANDING_FORMATTED;
          item.ADJUST = find.ADJUST;
          countAmount = parseInt(countAmount) + parseInt(item.ADJUST);
        }
        return item;
      });
      if (countAmount > parseInt(this.removeSeparator(totalAmount))) {
        error.push("The invoice amount cannot be higher than the total claims");
      }
      if (selectedInvoice.length === 0) {
        error.push("Please select invoice");
      }
    } else if (this.state.paymentMethod === "TRF") {
      if (!this.state.supplier) {
        error.push("Please select supplier");
      }
      if (!this.state.supplierSite) {
        error.push("Please select supplier site");
      }
    } else if (
      this.state.paymentMethod === "DEP" &&
      this.state.orgInitial === "AAM"
    ) {
      if (!this.state.supplier) {
        error.push("Please select supplier");
      }
      if (!this.state.supplierSite) {
        error.push("Please select supplier site");
      }
    }

    if (this.state.skb === "Y") {
      if (!this.state.fileSKB.filename) {
        error.push("Please attach document for exemption certificate");
      }
      if (this.state.skbNumber.length === 0) {
        error.push("SKB Number is empty");
      }

      if (this.state.skbDateFrom == null) {
        error.push("SKB Start Date is empty");
      }

      if (this.state.skbDateTo == null) {
        error.push("SKB End Date is empty");
      }
    }

    // let today = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
    // let dateToday = moment(today)
    // let expdate = moment(this.state.claimExpDate)
    // console.log('today', dateToday)
    // console.log('expdate', expdate)
    // console.log(dateToday.diff(expdate))
    // if (today > expdate) {
    //     error.push('Claim has exceeded the deadline')
    // }

    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  };

  renderSKBNumber = () => {
    if (this.state.skb === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
            SKB Number
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="inputEmail3"
              name="skbNumber"
              placeholder=""
              onChange={this.handleChangeInput.bind(this)}
              value={this.state.skbNumber}
            />
          </div>
        </div>
      );
    }
  };

  handleSkbDateFrom = (date) => {
    this.setState({ skbDateFrom: date });
  };

  handleSkbDateTo = (date) => {
    this.setState({ skbDateTo: date });
  };

  renderSKBDate = () => {
    if (this.state.skb === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3">
            SKB Date From
          </label>
          <div className="col-sm-3">
            <DatePicker
              placeholder="SKB Date from"
              selected={this.state.skbDateFrom}
              dateFormat="d-MMM-yyyy"
              className="form-control myDatePicker"
              popperPlacement="bottom-end"
              onChange={this.handleSkbDateFrom}
            />
          </div>
          &nbsp;{" "}
          <label htmlFor="inputEmail3" className="col-sm-1 col-form-label">
            To
          </label>
          <div className="col-sm-3">
            <DatePicker
              placeholder="SKB Date To"
              selected={this.state.skbDateTo}
              dateFormat="d-MMM-yyyy"
              className="form-control myDatePicker"
              popperPlacement="bottom-end"
              onChange={this.handleSkbDateTo}
            />
          </div>
        </div>
      );
    }
  };

  handleSubmit = () => {
    if (this.validateForm()) {
      let url = "/api/traces/v1/claim/submit";
      let {
        skbNumber,
        supplierId,
        supplier,
        supplierSite,
        potongTagihan,
        pphRate,
        pphType,
        dpp,
        pph,
        ppn,
        totalAmount,
        fileContainer,
        branchCode,
        kwitansi,
        programId,
        skbDateFrom,
        skbDateTo,
        customerId,
        skb,
        kwitansiAmount,
        kwitansiDate,
        // notes
      } = this.state;
      let { id } = this.props.match.params;
      let param = {
        customerId: customerId,
        branchCode: branchCode,
        skbNumber: skbNumber,
        supplierId: supplierId,
        supplier: supplier,
        supplierSite: supplierSite,
        program_customer_id: id,
        potongTagihan: potongTagihan,
        rate: pphRate,
        pphType: pphType,
        dpp: this.removeSeparator(dpp),
        ppn: this.removeSeparator(ppn) || 0,
        pph: this.removeSeparator(pph),
        totalAmount: this.removeSeparator(totalAmount),
        fileContainer: fileContainer,
        userId: this.state.user.user_id,
        invoice: this.state.selectedInvoice,
        paymentMethod: this.state.paymentMethod,
        norek: this.state.norek,
        npwp: this.state.npwp,
        skb: this.state.skb,
        fileSKB: this.state.fileSKB,
        fileLain: this.state.fileLain,
        fileTambahan: this.state.fileTambahan,
        fileRequired: this.state.fileRequired,
        taxNo: this.state.taxNo,
        taxDate:
          moment(this.state.taxDate, "YYYY-MM-DD HH:mm:ss").format(
            "YYYY-MM-DD"
          ) !== "Invalid date"
            ? moment(this.state.taxDate).format("YYYY-MM-DD")
            : null,
        bank: this.state.bankName,
        accOwner: this.state.accOwner,
        orgInitial: this.state.orgInitial,
        customerName: this.state.customerName,
        description: this.state.description,
        skpnumber: this.state.skpnumber,
        programType: this.state.programType,
        programStartDate: this.state.startDate,
        programEndDate: this.state.endDate,
        refNumber: this.state.refNumber,
        kwitansi: this.state.kwitansi,
        product_list: this.state.productList,
        header_npwp: this.state.header_npwp,
        header_npwp_name: this.state.header_npwp_name,
        header_npwp_address: this.state.header_npwp_address,
        user_name: this.state.user.username,
        source: "arman",
        menu: "claim",
        function: "submit",
        program_id: programId,
        skbdatefrom: moment(skbDateFrom).format("YYYY-MM-DD"),
        skbdateto: moment(skbDateTo).format("YYYY-MM-DD"),
        ppnrate: this.state.ppnrate,
        kwitansidate: moment(this.state.kwitansiDate).format("YYYY-MM-DD"),
        kwitansiamount: this.removeSeparator(this.state.kwitansiAmount),
        notes: this.state.notes,
      };

      this.setState({ loading: true });
      request.postTraces(url, param, {
        success: function (response) {
          if (response.data.data.claimId > 0) {
            this.setState({
              loading: false,
              success: response.data.message,
            });
            window.scrollTo(0, 0);
            let app = this;
            window.setTimeout(() => {
              app.props.history.push("/admin/claim/submit");
            }, 2000);
          } else {
            window.scrollTo(0, 0);
            this.setState({
              loading: false,
              error: [response.data.message],
            });
          }
        }.bind(this),
        error: function (e) {
          window.scrollTo(0, 0);
          this.setState({
            loading: false,
            error: [
              e.response.data.message || "Failed to submit, please try again",
            ],
          });
        }.bind(this),
      });
    }
  };

  handleCheckInvoice = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    let { selectedInvoice } = this.state;

    if (isChecked) {
      selectedInvoice.push({ CUSTOMER_TRX_ID: value });
    } else {
      let findIndex = _.findIndex(selectedInvoice, function (o) {
        return parseInt(o) === parseInt(value);
      });
      selectedInvoice.splice(findIndex, 1);
    }
    this.setState(selectedInvoice);
    this.calculateCheckedInvoice();
  };

  calculateCheckedInvoice = () => {
    let total = 0;
    let app = this;
    this.state.selectedInvoice.forEach((item, index) => {
      let find = _.find(app.state.listInvoice, function (o) {
        return parseInt(o.CUSTOMER_TRX_ID) === parseInt(item.CUSTOMER_TRX_ID);
      });
      let adjusted = find ? find.ADJUST : 0;
      console.log(find);
      total = total + parseInt(adjusted);
    });
    this.setState({ totalSelectedAmount: this.thousandSeparator(total) });
  };

  renderTableInvoice = () => {
    if (this.state.paymentMethod === "INV") {
      let app = this;
      const data = {
        columns: [
          {
            Header: "",
            minWidth: 30,
            accessor: "CUSTOMER_TRX_ID",
            Cell: (row) => {
              let findIndex = _.findIndex(
                this.state.selectedInvoice,
                function (o) {
                  return parseInt(o.CUSTOMER_TRX_ID) === parseInt(row.value);
                }
              );
              let checked = findIndex >= 0 ? true : false;
              return (
                <input
                  type="checkbox"
                  value={row.value}
                  onChange={this.handleCheckInvoice.bind(this)}
                  checked={checked}
                />
              );
            },
          },
          {
            Header: "INVOICE NO",
            accessor: "INVOICE_NUMBER",
          },
          {
            Header: "INVOICE DATE",
            accessor: "INVOICE_DATE",
            Cell: (row) => (
              <span>
                <span>
                  {row.value !== null
                    ? moment(row.value).format("DD-MMM-YYYY")
                    : ""}
                </span>
              </span>
            ),
          },
          {
            Header: "BALANCE",
            accessor: "OUTSTANDING_AMOUNT",
            className: "text-right",
            Cell: function (row) {
              return <span>{app.thousandSeparator(row.value || 0)}</span>;
            },
          },
          {
            Header: "ADJUST",
            accessor: "ADJUST",
            Cell: (row) => {
              return (
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={row.value}
                  data-outstanding={row.original.OUTSTANDING_AMOUNT}
                  data-trx-id={row.original.CUSTOMER_TRX_ID}
                  onChange={this.handleAdjust.bind(this)}
                />
              );
            },
          },
        ],
        rows: this.state.listInvoice,
      };
      return (
        <span>
          <h6>
            Total Amount Invoice Selected: {this.state.totalSelectedAmount}
          </h6>
          <ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
          />
        </span>
      );
    }
  };

  handleAdjust = (e) => {
    let value = e.target.value.replace(/[^0-9.]/g, "").replace(/\./g, "");
    console.log(value);
    let trxId = e.target.dataset.trxId;
    let outstanding = e.target.dataset.outstanding;
    let { listInvoice } = this.state;
    let findIndex = _.findIndex(listInvoice, function (o) {
      return parseInt(o.CUSTOMER_TRX_ID) === parseInt(trxId);
    });
    if (findIndex >= 0) {
      if (parseInt(value) > parseInt(outstanding)) {
        value = outstanding;
      }
      listInvoice[findIndex].ADJUST = value;
      this.setState(listInvoice);
      this.calculateCheckedInvoice();
    }
  };

  handleTaxDate = (date) => {
    this.setState({ taxDate: date });
    this.getPPNRATE(date);
  };

  renderTax = () => {
    let { ppn } = this.state;
    // if (parseInt(ppn) !== 0) {
    return (
      <div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
            Tax No
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              autoComplete="off"
              className="form-control"
              id="inputEmail3"
              name="taxNo"
              placeholder="Tax No"
              onChange={this.handleChangeInput.bind(this)}
              value={this.state.taxNo}
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
            Tax Date
          </label>
          <div className="col-sm-9">
            <DatePicker
              selected={this.state.taxDate}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleTaxDate}
            />
          </div>
        </div>
      </div>
    );
    // }
  };

  handleSKB = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    let app = this;
    if (isChecked) {
      this.setState({ skb: value, pph: 0, showSkbAttachment: true });
    } else {
      this.setState({
        skb: "N",
        showSkbAttachment: false,
        skbDateFrom: null,
        skbDateTo: null,
      });
      this.countPPH();
    }
    window.setTimeout(() => {
      app.calculateAmount();
    }, 100);
  };

  renderSKBAttachment = () => {
    if (this.state.showSkbAttachment) {
      return (
        <div className="col-md-8">
          <input
            type="file"
            className="form-control"
            data-type="SKB"
            onChange={this.handleUploadSingle.bind(this)}
          />
        </div>
      );
    }
  };

  customerInfo = () => {
    // console.log(this.state.productList);
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Customer
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="customerName"
                placeholder=""
                value={this.state.customerName}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP Name
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                disabled
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="header_npwp_name"
                placeholder=""
                value={this.state.header_npwp_name}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              Npwp Address
            </label>
            <div className="col-sm-9">
              <textarea
                autoComplete="off"
                disabled
                className="form-control"
                id="inputEmail3"
                name="headerNpwpAddress"
                placeholder=""
                value={this.state.header_npwp_address}
              />
            </div>
          </div>
          <div className="form-group row">
            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">
              NPWP / NIK
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                autoComplete="off"
                className="form-control"
                id="inputEmail3"
                name="header_npwp"
                placeholder=""
                onChange={this.handleChangeInput.bind(this)}
                value={this.state.header_npwp}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderDocumentTambahan = () => {
    return (
      <div className="row mb-2">
        <div className="col-md-2 mt-2">Additional Document</div>
        <div className="col-md-3">
          <input
            type="file"
            className="form-control"
            data-type="TAMBAHAN"
            onChange={this.handleUploadSingle.bind(this)}
          />
        </div>
        <div className="col-md-7 mt-2">
          {this.state.fileTambahan.filename.length > 0 ? (
            <span>
              <a
                href={this.state.fileTambahan.path}
                target="_blank"
                rel="noopener noreferrer"
              >
                {this.state.fileTambahan.filename}
              </a>
              &nbsp;
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  this.removeFileAdditional("tambahan");
                }}
              >
                <i className="fas fa-trash-alt"></i>
              </button>
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };

  handleRemoveFile = (type) => {
    let { fileTambahan, fileRequired, documentList } = this.state;
    if (type === "REQUIRED") {
      fileRequired.filename = "";
      fileRequired.path = "";
      this.setState({ fileRequired });
      this.setState({ documentList: [] });
    } else if (type === "ADDITIONAL") {
      fileTambahan.filename = "";
      fileTambahan.path = "";
      this.setState({ fileTambahan });
      this.setState({ additionalAttachment: 0 });
    }
  };

  previewFile = (e) => {
    const objectUrl = URL.createObjectURL(e);
    const pdfWindow = window.open();
    pdfWindow.location.href = objectUrl;
  };

  previewFileAdditional = (e) => {
    const objectUrl = URL.createObjectURL(e);
    const pdfWindow = window.open();
    pdfWindow.location.href = objectUrl;
  };

  downloadAttachment = (data, preview) => {
    this.setState({ loading: true });
    let url =
      data.doc === "bupot"
        ? `/api/traces/v1/tracking-email/download-surat-refund?bupot_file_key=${data.key}&bupot_filename=${data.filename}`
        : data.doc === "mandatory"
        ? `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${data.filename}&mandatory_file_key=${data.key}`
        : `/api/traces/v1/tracking-email/download-surat-refund?additional_FileName=${data.filename}&mandatory_file_key=${data.key}`;
    // let url_prev_mandatory = `/api/traces/v1/tracking-email/download-surat-refund?mandatory_filename=${this.state.fileRequired.filename}&mandatory_file_key=${data.key}`

    request.getTraces(url, {
      success: function (response) {
        if (response.data.statusCode === 400) {
          window.open(data.path, "_blank");
        } else {
          axios({
            url: response.config.url,
            method: "GET",
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${tracesToken()}`,
            },
          })
            .then((response) => {
              const href = URL.createObjectURL(response.data);

              const link = document.createElement("a");
              link.href = href;
              // doc_tambahan_filename
              link.setAttribute(
                "download",
                data.doc === "mandatory"
                  ? `CLAIM_${data.claim_id}.pdf`
                  : `${data.filename}.pdf`
              );
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(href);
              this.setState({ loading: false });
            })
            .catch((error) => {
              window.open(data.path, "_blank");
              this.setState({ loading: false });
            });
          // window.open(response.config.url, "_blank");
        }
      }.bind(this),
      error: function (e) {
        console.log(e);
        this.setState({ loading: true });
      }.bind(this),
    });
  };

  renderUploadSingle = (type) => {
    if (type === "REQUIRED") {
      if (
        this.state.fileRequired.path &&
        this.state.fileRequired.path.length > 0
      ) {
        return (
          <span>
            {this.state.newFile ? (
              <Link to="#" onClick={() => this.previewFile(this.state.newFile)}>
                {this.state.newFile.name}
              </Link>
            ) : (
              <Link
                to={"#"}
                onClick={() =>
                  this.downloadAttachment(this.state.fileRequired, "preview")
                }
              >
                {this.state.fileRequired.filename}
              </Link>
            )}
            &nbsp;{" "}
            <button
              className="btn btn-danger"
              onClick={this.handleRemoveFile.bind(this, "REQUIRED")}
            >
              <i className="fa fa-trash" />
            </button>
          </span>
        );
      } else {
        if (this.state.documentList.length === this.state.docs.length) {
          return (
            <div className="row mt-2">
              <div className="col-md-12">
                <input
                  type="file"
                  className="form-control"
                  data-type="REQUIRED"
                  onChange={this.handleUploadSingle.bind(this)}
                />
                <small>(*) merge all files before uploading</small>
              </div>
            </div>
          );
        }
      }
    } else if (type === "ADDITIONAL") {
      if (
        this.state.fileTambahan.path &&
        this.state.fileTambahan.path.length > 0
      ) {
        return (
          <span>
            {this.state.newAdditionalFile ? (
              <Link
                to="#"
                onClick={() =>
                  this.previewFileAdditional(this.state.newAdditionalFile)
                }
              >
                {this.state.newAdditionalFile.name}
              </Link>
            ) : (
              <Link
                to={"#"}
                onClick={() =>
                  this.downloadAttachment(this.state.fileTambahan, "preview")
                }
              >
                {this.state.fileTambahan.filename}
              </Link>
            )}
            &nbsp;{" "}
            <button
              className="btn btn-danger"
              onClick={this.handleRemoveFile.bind(this, "ADDITIONAL")}
            >
              <i className="fa fa-trash" />
            </button>
          </span>
        );
      }
      if (this.state.additionalAttachment) {
        return (
          <div className="row mt-2">
            <div className="col-md-12">
              <input
                type="file"
                className="form-control"
                data-type="TAMBAHAN"
                onChange={this.handleUploadSingle.bind(this)}
              />
            </div>
          </div>
        );
      }
    }
  };

  handleClickAdditional = (e) => {
    let is_checked = e.target.checked;
    let { fileTambahan } = this.state;
    if (is_checked) {
      this.setState({ additionalAttachment: 1 });
    } else {
      fileTambahan.filename = "";
      fileTambahan.path = "";
      this.setState({ additionalAttachment: 0 });
      this.setState(fileTambahan);
    }
  };

  renderDocumentAdditional = () => {
    let { fileTambahan } = this.state;
    if (fileTambahan.path.length === 0) {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={1}
                name="additionalAttachment"
                onClick={this.handleClickAdditional.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                Additional
              </label>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                Additional
              </label>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showError()}
                    {this.showSuccess()}
                    <form className="form-horizontal">
                      <h5>General Info</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Skp Number
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Skp"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.skpnumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Number
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="programNumber"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programNumber}
                              />
                            </div>
                          </div>

                          {/* <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Beban</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" autoComplete="off" disabled className="form-control" id="inputEmail3" name="beban" placeholder="Principal" onChange={this.handleChangeInput.bind(this)} value={this.state.beban} />
                                                        </div>
                                                    </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Principal
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="principalName"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.principalName}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Reff Number / SKP
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="refNumber"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.refNumber}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Type
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="programType"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.programType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Budget Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="budgetType"
                                placeholder="budgetType"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.budgetType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Descriptions
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="description"
                                placeholder="Principal"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.description}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Submitted Date
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.submitteddate}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Start Date
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.startDate}
                              />
                            </div>
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-2 col-form-label"
                            >
                              End Date
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.endDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Claim Exp Date
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.claimExpDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Program Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.program_budget.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Sisa Budget
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Budget"
                                name="budget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.sisabudget.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>

                          {/* <div className="form-group row">
                                                        <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">Assign Budget</label>
                                                        <div className="col-sm-8">
                                                            <input type="number" disabled autoComplete="off" className="form-control" id="inputEmail3" placeholder="Budget" name="budget" onChange={ this.handleChangeInput.bind(this) } value={ this.state.assign_budget } />
                                                        </div>
                                                    </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Sales Target
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder="Sales Target"
                                name="salesTarget"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.sales_target.toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="submitteddate"
                                value={this.state.pphType}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh Rate (%)
                            </label>
                            <div className="col-sm-4">
                              <input
                                disabled
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                placeholder=""
                                name="pphRate"
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Customer Info</h5>
                          {this.customerInfo()}
                        </div>
                      </div>
                      <hr />
                      <h5>Claim Info</h5>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Payment Method
                            </label>
                            <div className="col-sm-9 mt-2">
                              <div className="form-check form-check-inline">
                                <input
                                  disabled={
                                    this.state.orgInitial === "AAM" ||
                                    this.state.customerChannel.length > 0
                                      ? true
                                      : false
                                  }
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="inlineRadio1"
                                  value="INV"
                                  onChange={(e) => {
                                    this.setState({
                                      supplier: null,
                                      supplierId: "",
                                      supplierSite: "",
                                    });
                                    this.handleChangeInput(e);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio1"
                                >
                                  Deduct to receivable
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="inlineRadio2"
                                  checked={
                                    this.state.paymentMethod === "TRF"
                                      ? true
                                      : false
                                  }
                                  value="TRF"
                                  onChange={(e) => {
                                    this.setState({
                                      supplier: null,
                                      supplierId: "",
                                      supplierSite: "",
                                    });
                                    this.handleChangeInput(e);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio2"
                                >
                                  Transfer
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="paymentMethod"
                                  id="inlineRadio1"
                                  value="DEP"
                                  onChange={(e) => {
                                    this.setState({
                                      supplier: null,
                                      supplierId: "",
                                      supplierSite: "",
                                    });
                                    this.handleChangeInput(e);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="inlineRadio1"
                                >
                                  Deposit
                                </label>
                              </div>
                            </div>
                          </div>
                          {this.renderNorek()}
                          {/* <div className="form-group row">
                            <label htmlFor="inputEmail3" className="col-sm-3 col-form-label">NPWP / NIK</label>
                            <div className="col-sm-9">
                              <input type="text" autoComplete="off" className="form-control" id="inputEmail3" name="npwp" placeholder="NPWP" onChange={this.handleChangeInput.bind(this)} value={this.state.npwp} />
                            </div>
                          </div> */}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Customer PPh Type
                            </label>
                            <div className="col-sm-9">
                              {this.renderLovPPh()}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Rate <small>(%)</small>
                            </label>
                            <div className="col-sm-3">
                              <input
                                type="number"
                                autoComplete="off"
                                max="100"
                                min="0"
                                className="form-control"
                                id="inputEmail3"
                                name="pphRate"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pphRate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              DPP
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="dpp"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.dpp}
                              />
                            </div>
                          </div>
                          {this.renderTax()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPN Rate (%)
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ppnrate"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ppnrate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPN
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="ppn"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.ppn}
                                disabled
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              SKB
                            </label>
                            <div className="col-sm-1 mt-2">
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="skb"
                                  id="inlineRadio1"
                                  value="Y"
                                  onChange={this.handleSKB.bind(this)}
                                />
                              </div>
                            </div>
                            {this.renderSKBAttachment()}
                          </div>
                          {this.renderSKBNumber()}
                          {this.renderSKBDate()}
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              PPh
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                // disabled={this.state.showSkbAttachment}
                                disabled
                                className="form-control"
                                id="inputEmail3"
                                name="pph"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.pph}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Total Claim
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="totalAmount"
                                placeholder=""
                                onChange={this.handleChangeInput.bind(this)}
                                value={this.state.totalAmount}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Cust Receipt No.
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                maxLength="60"
                                className="form-control"
                                id="inputEmail3"
                                name="kwitansi"
                                placeholder="kwitansi"
                                onChange={this.handleChangeKwitansi.bind(this)}
                                value={this.state.kwitansi}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Cust Receipt Date.
                            </label>
                            <div className="col-sm-9">
                              <DatePicker
                                selected={this.state.kwitansiDate}
                                dateFormat="d-MMM-yyyy"
                                className="form-control"
                                popperPlacement="top-end"
                                onChange={this.handleKwitansiDate}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-3 col-form-label"
                            >
                              Cust Receipt Amount
                            </label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                autoComplete="off"
                                className="form-control"
                                id="inputEmail3"
                                name="pph"
                                placeholder=""
                                onChange={this.handlekwitansiAmount.bind(this)}
                                value={this.state.kwitansiAmount}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {this.renderTableInvoice()}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-12">
                          <h5>Products</h5>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-4 col-form-label"
                          >
                            Product Description
                          </label>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            Product Reff
                          </label>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            Product Budget
                          </label>
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-2 col-form-label"
                          >
                            Actual
                          </label>
                          {this.renderProduct()}
                        </div>
                      </div>
                      <hr />
                      <h5>Attachments</h5>
                      <div className="row">
                        <div className="col-md-6">
                          {/* {this.renderDocument()}
                          {this.renderDocumentTambahan()} */}
                          {this.renderDocumentV2()}
                          {this.renderUploadSingle("REQUIRED")}
                        </div>
                        <div className="col-md-6">
                          {this.renderDocumentAdditional()}
                          {this.renderUploadSingle("ADDITIONAL")}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label
                              htmlFor="inputEmail3"
                              className="col-sm-4 col-form-label"
                            >
                              Notes
                            </label>
                            <div className="col-sm-8">
                              <textarea
                                cols="10"
                                rows="3"
                                className="form-control"
                                name="notes"
                                onChange={this.handleChangeInput.bind(this)}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-4">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={this.handleSubmit.bind(this)}
                          >
                            <i className="fas fa-file-upload"></i> Submit
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            className="btn btn-warning"
                            onClick={() => {
                              this.props.history.push("admin/claim/submit");
                            }}
                          >
                            <i className="fas fa-arrow-left"></i> Back
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default Detail;
